var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { documentsApi } from '@data/rest/api';
import { gridKeys } from '@data/grid/gridActions';
import { widgetKeys } from '@data/widgets/widgetActions';
import { usePermittedActionsList } from '@data/permission/permissionActions';
import { selectActionsByEntityId } from '@data/permission/permission';
import { getMutationOptionsFactory } from '@util/query';
import { useMemo } from 'react';
export var documentKeys = Object.freeze({
    all: ['document'],
    lists: function () {
        return __spreadArray(__spreadArray([], __read(documentKeys.all), false), ['list'], false);
    },
    list: function (filter) {
        if (filter === void 0) { filter = 'all'; }
        return __spreadArray(__spreadArray([], __read(documentKeys.lists()), false), [filter], false);
    },
    actions: function () {
        return __spreadArray(__spreadArray([], __read(documentKeys.all), false), ['actions'], false);
    },
});
var mutationOptionsFactory = getMutationOptionsFactory();
function getDocuments() {
    return documentsApi.list();
}
export function useDocuments(options) {
    return useQuery(documentKeys.list(), getDocuments, options);
}
export function useDocumentsByParentId() {
    var documents = useDocuments();
    var data = useMemo(function () {
        var e_1, _a;
        var _b;
        var docsByParentMap = {};
        try {
            for (var _c = __values((_b = documents.data) !== null && _b !== void 0 ? _b : []), _d = _c.next(); !_d.done; _d = _c.next()) {
                var doc = _d.value;
                var parentId = doc.ParentId || 0; // use zero for root clusters
                var docsArray = docsByParentMap[parentId];
                if (!docsArray) {
                    docsArray = docsByParentMap[parentId] = [];
                }
                docsArray.push(doc);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return docsByParentMap;
    }, [documents]);
    return Object.freeze(data);
}
function createDocument(newDocument) {
    return documentsApi.create(newDocument);
}
export function useCreateDocument() {
    var key = documentKeys.all;
    var queryClient = useQueryClient();
    var options = mutationOptionsFactory.create('create', key, queryClient, [
        gridKeys.list(),
        widgetKeys.list(),
    ]);
    return useMutation(createDocument, options);
}
function updateDocument(updatedDocument) {
    var id = updatedDocument.id, orphan = updatedDocument.orphan, rest = __rest(updatedDocument, ["id", "orphan"]);
    return documentsApi.update(id, rest);
}
export function useUpdateDocument() {
    var key = documentKeys.all;
    var queryClient = useQueryClient();
    var options = mutationOptionsFactory.create('update', key, queryClient);
    return useMutation(updateDocument, options);
}
function deleteDocument(documentId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, documentsApi._delete(documentId)];
        });
    });
}
export function useDeleteDocument() {
    var key = documentKeys.all;
    var queryClient = useQueryClient();
    var options = mutationOptionsFactory.create('delete', key, queryClient, [
        gridKeys.list(),
        widgetKeys.list(),
    ]);
    return useMutation(deleteDocument, options);
}
function duplicateDocument(command) {
    return documentsApi.duplicate(command);
}
export function useDuplicateDocument() {
    var queryClient = useQueryClient();
    var queryKey = documentKeys.all;
    var dependantQueryKeys = [gridKeys.list(), widgetKeys.list()];
    return useMutation(duplicateDocument, {
        onSettled: function () {
            return __awaiter(this, void 0, void 0, function () {
                var dependantQueryKeys_1, dependantQueryKeys_1_1, qk, e_2_1;
                var e_2, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, queryClient.invalidateQueries(queryKey)];
                        case 1:
                            _b.sent();
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 7, 8, 9]);
                            dependantQueryKeys_1 = __values(dependantQueryKeys), dependantQueryKeys_1_1 = dependantQueryKeys_1.next();
                            _b.label = 3;
                        case 3:
                            if (!!dependantQueryKeys_1_1.done) return [3 /*break*/, 6];
                            qk = dependantQueryKeys_1_1.value;
                            return [4 /*yield*/, queryClient.invalidateQueries(qk)];
                        case 4:
                            _b.sent();
                            _b.label = 5;
                        case 5:
                            dependantQueryKeys_1_1 = dependantQueryKeys_1.next();
                            return [3 /*break*/, 3];
                        case 6: return [3 /*break*/, 9];
                        case 7:
                            e_2_1 = _b.sent();
                            e_2 = { error: e_2_1 };
                            return [3 /*break*/, 9];
                        case 8:
                            try {
                                if (dependantQueryKeys_1_1 && !dependantQueryKeys_1_1.done && (_a = dependantQueryKeys_1.return)) _a.call(dependantQueryKeys_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                            return [7 /*endfinally*/];
                        case 9: return [2 /*return*/];
                    }
                });
            });
        },
    });
}
function getDocumentActions() {
    return documentsApi.actions();
}
export function useActionsByDocumentId(options) {
    return usePermittedActionsList(documentKeys.actions(), getDocumentActions, __assign(__assign({}, options), { select: selectActionsByEntityId }));
}
